import {InputField} from './InputField';
import {ImageBackground} from './ImageBackground';

export const custom = {
  InputField,
  ImageBackground,
};
